import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { AuthShell, Input } from "@/pages/Login";

export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("Wachtwoord moet minimaal 6 tekens zijn.");
    if (password !== confirm) return setError("Wachtwoorden komen niet overeen.");
    setLoading(true);
    try { await resetPassword(token, password); setDone(true); setTimeout(() => navigate("/inloggen"), 2500); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  if (!token) return <AuthShell title="ONGELDIGE LINK" subtitle="Deze reset-link is niet geldig."><Link to="/wachtwoord-vergeten" className="font-semibold text-[#FF6A00] hover:underline">Vraag een nieuwe aan</Link></AuthShell>;

  return (
    <AuthShell title="NIEUW WACHTWOORD" subtitle="Stel je nieuwe wachtwoord in.">
      {done ? (
        <div className="text-center" data-testid="reset-done"><CheckCircle2 className="mx-auto mb-3 h-12 w-12 text-[#22C55E]" /><p className="text-[#cfcfcf]">Wachtwoord opnieuw ingesteld! Je wordt doorgestuurd naar inloggen...</p></div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          {error && <p className="rounded-lg border border-[#EF4444]/40 bg-[#EF4444]/10 p-3 text-sm text-[#EF4444]">{error}</p>}
          <Input label="Nieuw wachtwoord" type="password" value={password} onChange={setPassword} testid="reset-password" />
          <Input label="Bevestig wachtwoord" type="password" value={confirm} onChange={setConfirm} testid="reset-confirm" />
          <button type="submit" disabled={loading} data-testid="reset-submit" className="flex w-full items-center justify-center gap-2 rounded-full bg-[#FF6A00] py-3.5 font-bold text-[#111] hover:bg-[#FFB27A] active:scale-95 disabled:opacity-60">{loading && <Loader2 className="h-5 w-5 animate-spin" />} Wachtwoord opslaan</button>
        </form>
      )}
    </AuthShell>
  );
}
